export default __webpack_public_path__ + "static/1040-040784734b97ea421ba1f0677c6050d0.gif";